export default "__VITE_ASSET__4db61836__"